import { Box, Chip } from "@mui/material";
import Flex from "../../../../../components/Flex";
import PatientSelectScroll from "../../../../../components/PatientSelectScroll";
import Text from "../../../../../components/Text";

interface EmailToProps {
  patientList: { uuid: string; name: string }[];
  handleRemovePatient: (ind: number) => void;
  disableAddPatient: boolean;
  selectedPatient: any;
  handleAddPatient: (patient: any) => void;
  /**
   * Recipients are fixed by the screen that opened the composer, so the To
   * chips are not removable. Used where the mail is addressed to one specific
   * patient (Email Claim), which leaves nothing valid to send to once removed.
   */
  lockRecipients?: boolean;
}

export const EmailTo = ({
  patientList,
  handleRemovePatient,
  disableAddPatient,
  selectedPatient,
  handleAddPatient,
  lockRecipients = false,
}: EmailToProps) => {
  return (
    <Box display="flex" flexDirection="column" gap={1.5} width="100%">
      {!disableAddPatient && (
        <Box width="100%">
          <PatientSelectScroll
            label="Select Patient"
            placeholder="Select Patient"
            value={selectedPatient}
            onChange={(val) => handleAddPatient(val)}
          />
        </Box>
      )}
      <Flex alignItems="flex-start" gap={1} flexWrap="wrap">
        <Text variant="body2" color="text.secondary" sx={{ pt: 0.75 }}>
          To:
        </Text>
        <Flex gap={1} flexWrap="wrap" flex={1} minWidth={0}>
          {patientList?.map((it, ind) => (
            <Chip
              key={`${it?.uuid}-${ind}`}
              variant="outlined"
              size="small"
              label={<Text fontSize={12}>{it?.name}</Text>}
              onDelete={
                lockRecipients ? undefined : () => handleRemovePatient(ind)
              }
            />
          ))}
        </Flex>
      </Flex>
    </Box>
  );
};
